import React from "react";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu, message, Space, Select  } from "antd";

const handleButtonClick = (e) => {
  message.info("Click on left button.");
  console.log("click left button", e);
};

const handleMenuClick = (e) => {
  message.info("Click on menu item.");
  console.log("click", e);
};

const menu = (
  <Menu
    onClick={handleMenuClick}
    items={[
      {
        label: "Male",
        key: "1",
        icon: <UserOutlined />,
      },
      {
        label: "Female",
        key: "2",
        icon: <UserOutlined />,
      },
     
    ]}
  />
);
const { Option } = Select;

const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

const genderSelect = () => {
  return (
    
    <div className="acc-select-box">
    <Select
      defaultValue="Male"
      style={{
        width: 152,
      }}
      onChange={handleChange}
    >
      <Option value="Male">Male</Option>
      <Option value="Female">Female</Option>
    </Select>
   
    </div>

    
  );
};

export default genderSelect;
